module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1076.c4586a01.png";